<template>
  <div id="app">
    <router-view/>
    <!-- <iframe class="iframe" v-show="true" src="http://121.40.28.76:8761/home/ftpuser/ftp/50/play.html" frameborder="0" style="width:100%;height:100%"></iframe> -->
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style lang="less">
    @import "./components/css/global";
    #app{
      height:100%;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue